module.exports = __webpack_public_path__ + "static/media/Wizehire-growth-final.d452f597.png";